import { Sparkles } from "lucide-react";
import { ReviewItem } from "./ReviewItem";

/**
 * Listagem das avaliações (já paginada pelo caller — recebe só os itens da
 * página atual). `totalCount` opcional pra exibir total no header.
 */
export function ReviewsList({ reviews, totalCount, dimensions = [], onOpenPedido, onToggleHidden, hiddenPending = {} }) {
  const hasNone = !reviews?.length;
  const total = totalCount ?? reviews.length;
  return (
    <div className="bg-card border rounded-2xl overflow-hidden">
      <div className="px-5 py-4 border-b">
        <h2 className="text-lg font-bold">Últimas avaliações</h2>
        <p className="text-xs text-muted-foreground">
          {total} respondida{total === 1 ? "" : "s"}
        </p>
      </div>
      {hasNone ? (
        <div className="p-10 text-center text-muted-foreground text-sm">
          <Sparkles className="w-10 h-10 mx-auto opacity-30 mb-3" />
          Nenhuma avaliação recebida ainda.<br />
          Ative a campanha de Avaliação em <strong>Impulsione → Campanhas</strong>.
        </div>
      ) : (
        <ul className="divide-y">
          {reviews.map((r) => (
            <ReviewItem
              key={r.id}
              review={r}
              dimensions={dimensions}
              actions={{
                onOpenPedido,
                onToggleHidden,
                hiddenPending: !!hiddenPending[r.id],
              }}
            />
          ))}
        </ul>
      )}
    </div>
  );
}
